import React from 'react';
import type { ModePreset } from '../types/api';

const PRESETS: Array<{ value: ModePreset; label: string; desc: string }> = [
  { value: 'BICYCLE,TRANSIT', label: 'Bike→Transit→Bike', desc: 'Bike to stop, bring bike on transit, bike from stop' },
  { value: 'TRANSIT,WALK', label: 'Walk + Transit', desc: 'Walk to stop, ride transit, walk to destination' },
  { value: 'BICYCLE', label: 'Bike Only', desc: 'Bike the whole way' },
  { value: 'WALK', label: 'Walk Only', desc: 'Walking directions only' },
];

interface ModeSelectorProps {
  mode: ModePreset;
  setMode: (m: ModePreset) => void;
}

export default function ModeSelector({ mode, setMode }: ModeSelectorProps) {
  return (
    <div className="mode-selector">
      {PRESETS.map((p) => (
        <button
          key={p.value}
          className={`mode-btn ${mode === p.value ? 'active' : ''}`}
          onClick={() => setMode(p.value)}
          title={p.desc}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
